import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import { pick, useSite } from "../useSite";

const fallback = {
  title: "Ceylon, hosted properly",
  subtitle: "About us",
  body: "It is our role to provide a comfortable, friendly, and safe service so you can visit the beautiful places of Sri Lanka and actually enjoy the vacation.\n\nOur vision\n\nLeaving traces of Ceylon hospitality in your heart.\n\nOur mission\n\nFrom the beginning our mission has been to put our guests’ wishes first: to understand what they want, to meet a global standard of travel, and to offer an honest experience of Ceylon culture with the safety travelers need. We extend that hospitality through a careful team and a service that stays personal.\n\nVishmi Travels (Pvt) Ltd is a registered Sri Lankan company, PV00258188. Journeys are private. You travel with your own driver, in hotels we would stay in ourselves, on a route written for your dates rather than a coach timetable.",
  link: "/enquire",
  linkLabel: "Start a conversation",
};

export default function About() {
  const { block } = useSite();
  const about = pick(block("about"), fallback) || {};
  const parts = String(about.body || "").split(/\n\n+/).filter(Boolean);

  return (
    <Layout>
      <Seo
        title={about.title || "About Vishmi Travels"}
        description="Vishmi Travels provides a comfortable, friendly, and safe way to see Sri Lanka. Vision: leaving traces of Ceylon hospitality in your heart."
        path="/about"
      />
      <header className="page-hero">
        <div className="wrap">
          {about.subtitle ? <p className="eyebrow">{about.subtitle}</p> : null}
          {about.title ? <h1>{about.title}</h1> : null}
        </div>
      </header>
      <section className="section">
        <div className="wrap prose">
          {parts.map((paragraph) => (
            paragraph.length < 40 && !paragraph.includes(".")
              ? <h2 key={paragraph}>{paragraph}</h2>
              : <p key={paragraph}>{paragraph}</p>
          ))}
          {about.linkLabel ? (
            <p>
              <Link className="btn" to={about.link || "/enquire"}>{about.linkLabel}</Link>
            </p>
          ) : null}
        </div>
      </section>
    </Layout>
  );
}
